export function addCurrent(techinicalteam) {
    return {
        type: 'ADD_CURRENT',
        techinicalteam,
    }
}
